import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SalonCategoryModel } from '../../models/SalonCategoryModel'


export interface SalonCategoryState {
    SalonCategory: SalonCategoryModel
    SalonCategoryList: SalonCategoryModel[]
}

const initialState: SalonCategoryState = {
    SalonCategory: {} as SalonCategoryModel,
    SalonCategoryList: [],
}

export const SalonCategorySlice = createSlice({
    name: 'salonCategory',
    initialState,
    reducers: {
        setSalonCategory: (state, action: PayloadAction<SalonCategoryModel[]>) => {
            state.SalonCategoryList = action.payload
        },
        saveSalonCategory: (state, action: PayloadAction<SalonCategoryModel>) => {
            let room = action.payload
            if (room.Id > 0) {
                let defaultModel: SalonCategoryModel = { Id: 0, CategoryName: room.CategoryName }
                let currentRoom =
                    state.SalonCategoryList.find((c) => c.Id === room.Id) || defaultModel
                    currentRoom.CategoryName = room.CategoryName
            } else {
                room.Id = (Math.max(...state.SalonCategoryList.map((c) => c.Id)) || 0) + 1
                state.SalonCategoryList.push(room)
            }
        },
        getSalonCategoryById: (state, action: PayloadAction<number>) => {
            let id = action.payload
            let SalonCategory: SalonCategoryModel = {} as SalonCategoryModel
            if (id > 0) {
                let currentSalonCategory: SalonCategoryModel[] = state.SalonCategoryList
                SalonCategory = currentSalonCategory.find((c) => c.Id === id) || ({} as SalonCategoryModel)
            }

            state.SalonCategory = SalonCategory
        },
        deleteSalonCategory: (state, action: PayloadAction<string>) => {
            let id: string = action.payload
            let ids: number[] = id.split(',').map((i) => parseInt(i))
            if (ids && ids.length > 0) {
                let currentSalonCategory: SalonCategoryModel[] = state.SalonCategoryList
                state.SalonCategoryList = currentSalonCategory.filter((c) => !ids.includes(c.Id))
            }
        },
    },
})

export const { setSalonCategory, saveSalonCategory, getSalonCategoryById, deleteSalonCategory } =
SalonCategorySlice.actions

export default SalonCategorySlice.reducer
